import { TimeOffRequestSummaryStatusDTO } from '@/modules/time-tracking/types/dto/worklogs-time-off-summary.dto';

import { TimeOffRequestSummaryStatus } from '../types/time-tracking';

const TIME_OFF_REQUEST_SUMMARY_STATUS_MAP: Record<
  TimeOffRequestSummaryStatusDTO,
  TimeOffRequestSummaryStatus
> = {
  [TimeOffRequestSummaryStatusDTO.PENDING]: TimeOffRequestSummaryStatus.PENDING,
  [TimeOffRequestSummaryStatusDTO.APPROVED]: TimeOffRequestSummaryStatus.APPROVED,
};

export const mapTimeOffRequestSummaryStatusFromDTO = (
  status: TimeOffRequestSummaryStatusDTO
): TimeOffRequestSummaryStatus => TIME_OFF_REQUEST_SUMMARY_STATUS_MAP[status];
